import { render, staticRenderFns } from "./CadastreBuildingEditModal.vue?vue&type=template&id=24dca624&"
import script from "./CadastreBuildingEditModal.vue?vue&type=script&lang=js&"
export * from "./CadastreBuildingEditModal.vue?vue&type=script&lang=js&"
import style0 from "./CadastreBuildingEditModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports